/**
 * @param {boolean} hasAdminAccess
 * @returns {string}
 */
const getConfirmAccessTitleText = (hasAdminAccess) => {
	return `Are you sure you want to ${hasAdminAccess ? "revoke" : "grant"} access for this add-in?`;
};

export default getConfirmAccessTitleText;
